//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import { cloneDeep } from 'lodash'

export default {
  nuxtI18n: {
    paths: {
      br: '/contato',
      en: '/contact',
      es: '/contacto'
    }
  },

  async asyncData({ $api }) {
    try {
      const departmentOptions = await $api.contact.showDepartments()

      return {
        departmentOptions
      }
    } catch (err) {
      $api.instance.handleResponseError(err)
    }
  },

  data() {
    return {
      breadcrumbs: [
        {
          name: this.$t('home'),
          path: '/'
        },
        {
          name: this.$t('title'),
          path: '/contato'
        }
      ],
      form: {},
      empty: {
        name: '',
        email: '',
        department_id: '',
        where_you_work: '',
        phone: '',
        zipcode: '',
        address: '',
        number: '',
        neighborhood: '',
        city: '',
        uf: '',
        country: '',
        message: '',
        share_infos: false
      },
      processing: false,
      departmentOptions: []
    }
  },

  head() {
    return this.$helpers.seoBuilder(this, {
      staticTitle: this.$t('title')
    })
  },

  computed: {
    phoneMask() {
      if (this.form.phone && this.form.phone.length > 14) {
        return '(##) #####-####'
      } else {
        return '(##) ####-####?#'
      }
    },

    phoneMaskDDI() {
      if (this.form.phone && this.form.phone.length > 18) {
        return '+## (##) #####-####'
      } else {
        return '+## (##) ####-####?#'
      }
    },

    ...mapGetters({
      contact: 'layout/getContact',
      privacy: 'layout/getPrivacy'
    })
  },

  mounted() {
    this.setForm()
  },

  methods: {
    getAddress(event) {
      const value = event.target.value
      const cep = value.replace(/\D/g, '')
      const cepIsValid = /^[0-9]{8}$/

      if (cep !== '') {
        if (cepIsValid.test(cep)) {
          this.$axios
            .$get('https://viacep.com.br/ws/' + cep + '/json')
            .then((response) => {
              if (!('erro' in response)) {
                this.form.neighborhood = response.bairro
                this.form.address = response.logradouro
                this.form.city = response.localidade
                this.form.uf = response.uf

                const formNumber = document.getElementById('number')
                if (formNumber) {
                  formNumber.focus()
                }
              } else {
                this.form.neighborhood = ''
                this.form.address = ''
                this.form.uf = ''
                this.form.city = ''
              }
            })
            .catch((err) => console.log(err))
        }
      }
    },

    async send() {
      try {
        this.processing = true

        // Form treatment
        if (!this.form.country) {
          this.form.country = 'Brasil'
        }

        // Send Form
        await this.$api.contact.send(this.form)

        this.$store.dispatch('modal/show', {
          type: 'success',
          title: this.$t('modal.success.title'),
          message: this.$t('modal.success.description')
        })

        // Reset form
        this.setForm()

        this.processing = false
      } catch (err) {
        console.log(err)

        this.processing = false

        this.$store.dispatch('modal/show', {
          type: 'danger',
          title: this.$t('modal.error.title'),
          message: this.$t('modal.error.description')
        })
      }
    },

    setForm() {
      this.form = cloneDeep(this.empty)
    }
  }
}
